module.exports = "<div [formGroup]=\"form\" class=\"form-group\">\n  <label class=\"col-sm-2 control-label\">{{displayName}}</label>\n  <div class=\"col-sm-10\">\n    <textarea id=\"tinymce-{{field}}\" [formControlName]=\"field\" class=\"form-control\"></textarea>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/formcontrol-tinymce/formcontrol-tinymce.component.html
// module id = 305
// module chunks = 0 1